import Cookies from 'js-cookie';
import Accordion from 'accordion-js';

//! all attributes
//! data-jscookieconsent
//! data-jscookieconsent-disabled
//! data-jscookieconsent-detailcontent
//! data-jscookieconsent-detailtable
//! data-jscookieconsent-option

//! data-jscookieconsent-accept
//! data-jscookieconsent-details
//! data-jscookieconsent-savedetails
//! data-jscookieconsent-script

//! data-jscookieconsent-disable
//! data-jscookieconsent-disabletext
//! data-jscookieconsent-disableerror

//! data-jscookieconsent-donottrack
//! data-jscookieconsent-donottrackclose
//! data-jscookieconsent-donottracktime

//! data-jscookieconsent-overlay
//! data-jscookieconsent-overlaytoggle

export default class JsCookieConsent {
	constructor(settings = {}) {
		this.attrName = settings.attrName || 'jscookieconsent';
		this.cookieconsentEl = document.querySelector(`[data-${this.attrName}]`);

		window[`${this.attrName}`] = this;

		if (this.cookieconsentEl) {
			//create settings
			this.settings = {
				expireDays: settings.expireDays || 30,
				optionCookie: settings.optionCookie || 'cookieoption',

				options: settings.options || { required: {}, analysis: {}, marketing: {} },

				detailsHeight: settings.detailsHeight || '200px',
				disableTextClasses: settings.disableTextClasses || '',

				doNotTrack: settings.doNotTrack || true,
				doNotTrackHideTime: settings.doNotTrackHideTime || 5000,
				doNotTrackAnimationTime: settings.doNotTrackAnimationTime || 2000,
			};

			this.init();
			this.initEvents();
		} else {
			this.consoleMessage();
		}
	}

	init() {
		this.domain = window.location.hostname;
		this.isIE = window.navigator.userAgent.includes('Trident');
		this.isDoNotTrackEnabled = false;

		//init DOM
		this.detailContent = this.cookieconsentEl.querySelector(
			`[data-${this.attrName}-detailcontent]`
		);
		this.detailTable = this.cookieconsentEl.querySelector(`[data-${this.attrName}-detailtable]`);

		this.isDisabled = document.querySelector(`[data-${this.attrName}-disabled]`);
		this.cookieOptionInputs = Array.from(
			this.cookieconsentEl.querySelectorAll(`[data-${this.attrName}-option]`)
		);

		this.acceptBtns = Array.from(document.querySelectorAll(`[data-${this.attrName}-accept]`));
		this.detailsBtn = this.cookieconsentEl.querySelector(`[data-${this.attrName}-details]`);
		this.saveDetailsBtn = this.cookieconsentEl.querySelector(`[data-${this.attrName}-savedetails]`);
		this.disableScriptBtns = Array.from(
			document.querySelectorAll(`[data-${this.attrName}-disable]`)
		);

		this.overlayEl = document.querySelector(`[data-${this.attrName}-overlay]`);
		this.overlayToggleBtns = Array.from(
			document.querySelectorAll(`[data-${this.attrName}-overlaytoggle]`)
		);

		this.trackingScripts = Array.from(document.querySelectorAll(`[data-${this.attrName}-script]`));

		//init element
		let cookie = Cookies.get(this.settings.optionCookie);
		this.currentCookieOptions = {};
		try {
			if (cookie) this.currentCookieOptions = JSON.parse(cookie);
		} catch (error) {
			this.currentCookieOptions = {};
			cookie = false;
		}

		if (!cookie) {
			//init doNotTrack
			this.initDoNotTrack();

			if (!this.isDisabled && !this.isDoNotTrackEnabled) {
				//open cookieconsent
				this.cookieconsentEl.classList.remove('hidden');
			}
		} else {
			if (!this.isDoNotTrackEnabled) this.changeScriptType();
			this.removeCookies();
		}
	}

	initEvents() {
		if (this.acceptBtns)
			this.acceptBtns.forEach(btn => btn.addEventListener('click', ::this.onAcceptBtnClick));

		if (this.overlayToggleBtns)
			this.overlayToggleBtns.forEach(btn =>
				btn.addEventListener('click', ::this.onToogleOverlayBtnClick)
			);

		if (this.disableScriptBtns)
			this.disableScriptBtns.forEach(btn =>
				btn.addEventListener('click', ::this.onDisableScriptBtnClick)
			);

		if (this.detailContent) {
			this.detailAccordion = new Accordion(this.detailContent, {
				duration: 350,
				activeClass: 'is-open',
			});

			new Accordion(this.detailTable, {
				duration: 350,
				activeClass: 'is-open',
			});

			this.detailsBtn && this.detailsBtn.addEventListener('click', ::this.onDetailsBtnClick);
			this.saveDetailsBtn &&
				this.saveDetailsBtn.addEventListener('click', ::this.onSaveDetailsBtnClick);
		} else {
			this.consoleMessage('detailcontent');
		}
	}

	//Cookie Option
	setCookieOption(option) {
		if (option) {
			let expires = new Date();
			expires.setTime(expires.getTime() + 3600000 * 24 * this.settings.expireDays);

			Cookies.set(this.settings.optionCookie, option, { expires: expires });
			this.currentCookieOptions = option;
		} else {
			this.consoleMessage('cookie');
		}
	}

	createCookieOptionFromInputs(setAll = 'no') {
		if (this.cookieOptionInputs.length) {
			let option = {};

			this.cookieOptionInputs.forEach(el => {
				const optionName = el.dataset[`${this.attrName}Option`];

				if (!this.settings.options[optionName].required) {
					if (setAll === 'no') {
						option[optionName] = el.checked;
					} else {
						option[optionName] = setAll;
					}
				}
			});

			this.setCookieOption(option);
		} else {
			this.consoleMessage('option');
		}
	}

	//On btn clicks
	onAcceptBtnClick() {
		//Set CookieOption
		this.createCookieOptionFromInputs(true);
		//Load Scripts
		this.changeScriptType();
		//Close Cookie Consent
		this.closeCookieConsent();
	}

	onDetailsBtnClick() {
		if (this.detailContent) {
			this.detailAccordion.toggle(0);

			this.detailsBtn.classList.add('hidden');
			this.saveDetailsBtn.classList.remove('hidden');
		} else {
			this.consoleMessage('detailcontent');
		}
	}

	onSaveDetailsBtnClick() {
		//Set CookieOption
		this.createCookieOptionFromInputs();
		//Remove Cookies
		this.removeCookies();
		//Load Scripts
		this.changeScriptType();
		//Close Cookie Consent
		this.closeCookieConsent();
	}

	//disable option
	onDisableScriptBtnClick(el) {
		el.preventDefault();

		const singleOptionToDisable = el.target.getAttribute(`data-${this.attrName}-disable`);
		const text = el.target.getAttribute(`data-${this.attrName}-disabletext`) || 'deactivated';
		const error =
			el.target.getAttribute(`data-${this.attrName}-disableerror`) ||
			`Can't deactivated cookies before you accept the cookieconsent!`;
		const messageEl = document.createElement('span');
		const currentCookieOption = Object.keys(this.currentCookieOptions);

		if (this.settings.disableTextClasses) {
			messageEl.classList.add(this.settings.disableTextClasses);
		}

		if (currentCookieOption.length) {
			if (singleOptionToDisable !== 'all') {
				this.currentCookieOptions[singleOptionToDisable] = false;
			} else {
				currentCookieOption.forEach(key => {
					this.currentCookieOptions[key] = false;
				});
			}

			this.changeScriptType('plain', singleOptionToDisable);
			this.setCookieOption(this.currentCookieOptions);
			this.removeCookies();

			messageEl.innerHTML = text;
		} else {
			messageEl.innerHTML = error;
			messageEl.classList.add('show-error');
		}

		el.target.parentNode.replaceChild(messageEl, el.target);
	}

	//Close Cookie Consent
	closeCookieConsent() {
		this.cookieconsentEl.classList.add('hidden');

		if (this.overlayEl) this.overlayEl.classList.add('hidden');
	}

	//Toggle Overlay
	onToogleOverlayBtnClick() {
		if (this.overlayEl.classList.contains('hidden')) {
			this.overlayEl.classList.remove('hidden');
			this.cookieconsentEl.classList.add('hidden');
		} else {
			this.overlayEl.classList.add('hidden');
			this.cookieconsentEl.classList.remove('hidden');
		}
	}

	changeScriptType(type = 'javascript', singleOptionToDisable = '') {
		if (this.trackingScripts.length) {
			this.trackingScripts.forEach(el => {
				let dataValue = el.dataset[`${this.attrName}Script`];
				const option = this.currentCookieOptions[dataValue];

				if (dataValue === singleOptionToDisable && type === 'plain') {
					el.type = 'text/plain';
				} else if (singleOptionToDisable === 'all' && type === 'plain') {
					el.type = 'text/plain';
				}

				if (option && type === 'javascript') {
					const newScriptEl = document.createElement('script');
					for (let i = 0; i < el.attributes.length; i++) {
						const attribute = el.attributes[i];
						if (attribute.value !== '') {
							newScriptEl.setAttribute(attribute.name, attribute.value);
						}
						newScriptEl.setAttribute('type', 'text/javascript');
					}
					newScriptEl.text = el.text;
					el.parentNode.insertBefore(newScriptEl, el);
					el.parentNode.removeChild(el);
				} else if (typeof option === 'undefined' && type === 'javascript') {
					this.consoleMessage('scriptoptionjavascript');
				}
			});
		} else {
			this.consoleMessage('script');
		}
	}

	//Remove Cookies
	removeCookies() {
		Object.keys(this.settings.options).forEach(key => {
			const settings = this.settings.options[key];
			const cookies = settings.cookies || 0;
			const isRequired = settings.required || false;
			const isAllowed = this.currentCookieOptions[key];

			if (!isRequired && cookies.length && !isAllowed) {
				cookies.forEach(cookie => {
					Cookies.remove(cookie, { path: '', domain: this.isIE ? '' : this.domain });
				});
			} else if (!cookies) {
				this.consoleMessage('optionobjcookies');
			}
		});
	}

	//Do Not Track
	initDoNotTrack() {
		if (this.settings.doNotTrack) {
			if (
				window.doNotTrack ||
				navigator.doNotTrack ||
				navigator.msDoNotTrack ||
				(window.external && 'msTrackingProtectionEnabled' in window.external)
			) {
				// The browser supports Do Not Track!
				if (
					window.doNotTrack === '1' ||
					navigator.doNotTrack === 'yes' ||
					navigator.doNotTrack === '1' ||
					navigator.msDoNotTrack === '1' ||
					(window.external &&
						window.external.msTrackingProtectionEnabled &&
						window.external.msTrackingProtectionEnabled())
				) {
					// Do Not Track is enabled!
					this.isDoNotTrackEnabled = true;
				}
			}

			if (this.isDoNotTrackEnabled) {
				this.doNotTrackEl = document.querySelector(`[data-${this.attrName}-donottrack]`);
				this.doNotTrackTimeEl = document.querySelector(`[data-${this.attrName}-donottracktime]`);

				if (this.doNotTrackEl) {
					this.doNotTrackEl.addEventListener('mouseout', ::this.resumeTimeout);
					this.doNotTrackEl.addEventListener('mouseover', ::this.pauseTimeout);

					this.doNotTrackElCloseBtn = this.doNotTrackEl.querySelector(
						`[data-${this.attrName}-donottrackclose]`
					);
					this.doNotTrackElCloseBtn &&
						this.doNotTrackElCloseBtn.addEventListener('click', ::this.onDoNotTrackElCloseBtnClick);

					this.showDoNotTrackEl();
				} else {
					this.consoleMessage('donottrack');
				}
			}
		}
	}

	showDoNotTrackEl() {
		this.doNotTrackEl.classList.remove('hidden');
		this.createCookieOptionFromInputs(false);

		if (this.settings.doNotTrackHideTime !== -1) {
			this.doNotTrackTimeOut = new Timer(
				() => {
					this.hideDoNotTrackEl();
				},
				this.settings.doNotTrackHideTime,
				this.doNotTrackTimeEl
			);
		}
	}

	hideDoNotTrackEl() {
		this.doNotTrackEl.classList.add('is-animated');

		setTimeout(() => {
			this.doNotTrackEl.classList.add('hidden');
			this.doNotTrackEl.classList.remove('is-animated');
		}, this.settings.doNotTrackAnimationTime);
	}

	resumeTimeout() {
		this.doNotTrackTimeOut && this.doNotTrackTimeOut.resume();
	}

	pauseTimeout() {
		this.doNotTrackTimeOut && this.doNotTrackTimeOut.pause();
	}

	onDoNotTrackElCloseBtnClick() {
		this.doNotTrackTimeOut && this.doNotTrackTimeOut.stop();
		this.hideDoNotTrackEl();
	}

	//Set Cookie with the CookieConsent-Script
	setCookie(option, cookiename, cookievalue = '', expiresDays = 1) {
		const ccOptions = this.settings.options;

		if (option && cookiename && expiresDays) {
			let expires = '';

			if (!ccOptions[option].session) {
				expires = new Date();
				expires.setTime(expires.getTime() + 3600000 * 24 * expiresDays);
			}

			Cookies.set(cookiename, cookievalue, { expires: expires });
		} else {
			console.error(`CookieConsent can't create the cookie.`);
		}
	}

	//Errors
	consoleMessage(error = 'default') {
		switch (error) {
			case 'option':
				console.error(
					`CookieConsent DOM not found: You must define an element with the attributes data-${this.attrName}-option!`
				);
				break;
			case 'detailcontent':
				console.error(
					`CookieConsent DOM not found: You must define an element with the attribute data-${this.attrName}-detailcontent!`
				);
				break;
			case 'script':
				console.error(
					`CookieConsent DOM not found: You must define an element with the attribute data-${this.attrName}-script!`
				);
				break;
			case 'scriptoption':
				console.error(
					`CookieConsent Option not found: The value from data-${this.attrName}-script was not declared as option!`
				);
				break;
			case 'cookie':
				console.error(`CookieConsent cookie could not be set!`);
				break;
			case 'optionobjcookies':
				console.error(`CookieConsent Option not found: options-obj cookies was not set!`);
				break;
			case 'donottrack':
				console.error(
					`CookieConsent "Do not Track" is enabled but can't find DOM: You must define an element with the attribute data-${this.attrName}-donottrack!`
				);
				break;
			default:
				console.error(
					`CookieConsent DOM not found: You must define an element with the attribute data-${this.attrName}!`
				);
				break;
		}
	}
}

class Timer {
	constructor(callback, delay, timeEl) {
		this.delay = delay;
		this.callback = callback;
		this.timerId = delay;
		this.start = new Date();
		this.remaining = delay;

		this.timeEl = timeEl;
		this.progressPercent = 0;

		this.resume();
	}

	pause() {
		window.clearTimeout(this.timerId);
		this.remaining -= new Date() - this.start;

		if (this.timeEl) window.clearInterval(this.progress);
	}

	resume() {
		this.start = new Date();
		this.timerId = window.setTimeout(this.callback, this.remaining);

		if (this.timeEl) {
			this.progressInterval(this.remaining);
		}
	}

	stop() {
		window.clearTimeout(this.timerId);
		if (this.timeEl) window.clearInterval(this.progress);
	}

	progressInterval(currentTime) {
		let progressPercent = 0;
		let time = 0;
		const startTime = new Date();

		this.progress = setInterval(() => {
			time = currentTime;
			time -= new Date() - startTime;

			if (time <= 0) {
				progressPercent = 100;
				clearInterval(this.progress);
			} else {
				progressPercent = ((this.delay - time) / this.delay) * 100;
			}

			this.timeEl.style.width = `${progressPercent}%`;
		}, 10);
	}
}
